import template from './VariationRadioButton.vhtml';

export default {
	name: 'VariationRadioButton',
	template: template,
	props: ['variationId', 'currentVariationId', 'attributes'],
	computed: {
		isSelected() {
			return this.variationId === this.currentVariationId;
		},
	},
	methods: {
		updateData() {
			this.$emit('input', this.variationId);
		}
	},
};
